/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-undef */
import { useState, useEffect, useCallback, useRef } from 'react';
import { readContract } from '@wagmi/core';
import '../App.css';
import MultiCallAbi from '../config/MultiCallAbi.json';
import '../styles/MainContainer.css';
import LaunchpadCard from '../components/LaunchpadCard';
import ClipLoader from 'react-spinners/ClipLoader';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';
import Cookies from 'universal-cookie';
import { imageUrl, supportedChainIds, chainLogos, projectName, initialEth1, apiUrl } from '../utils/constants.ts';
import { ethPriceApiUrl } from '../utils/priceApi.ts';
import { getMulticallAddress } from '../utils/addressHelpers.ts';
import Slider from '../components/Slider.jsx';
import Web3 from 'web3';
import rot13 from '../utils/encode.ts';
import { useQueryParam, StringParam } from 'use-query-params';
import { config } from '../config.jsx';
import bannerVideo from '../assets/banner.mp4'; // Importar el video banner para usarlo en esta página

// Define the breakpoint (e.g., 640px for sm)
const SMALL_SCREEN_BREAKPOINT = 640;
// Intervalo de actualización en milisegundos (30 segundos)
const UPDATE_INTERVAL = 30000;

const App = ({
  notifications,
  unreadNotificationCount,
  onNotificationClick,
  onClearAllNotifications,
}) => {
  const history = useHistory();
  let [loading, setLoading] = useState(false);
  const [funLists, setFunListData] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalLength, setTotalLength] = useState(0);
  const [allLists, setAllLists] = useState([]);
  const cookies = new Cookies();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  let [ref] = useQueryParam('ref', StringParam);
  /** @type {string[]} */
  const [activeStreamAddrs, setActiveStreamAddrs] = useState([]);
  // State to track screen size
  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < SMALL_SCREEN_BREAKPOINT);

  // Effect to handle window resize
  useEffect(() => {
    const checkScreenSize = () => {
      setIsSmallScreen(window.innerWidth < SMALL_SCREEN_BREAKPOINT);
    };

    window.addEventListener('resize', checkScreenSize);

    // Cleanup function to remove listener
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []); // Empty dependency array ensures this runs only on mount and unmount

  // Define contentStyle conditionally based on screen size
  const contentStyle = {
    paddingTop: isSmallScreen ? '1.5rem' : '1.5rem', // Reducido de 6.5rem a 1.5rem
    paddingBottom: isSmallScreen ? '2.25rem' : '2.25rem', // Reducido de 6.25rem a 2.25rem
  };

  if (ref) {
    if (Web3.utils.isAddress(rot13(ref))) {
      cookies.set('ref', ref);
    }
  }

  // Función para obtener datos (refactorizada desde useEffect)
  const FetchData = useCallback(async (isInitialLoad = false) => {
    try {
      // Solo mostrar el indicador de carga en la carga inicial
      if (isInitialLoad) {
        setLoading(true);
      }
      
      // Limpiar los datos anteriores solo en la carga inicial
      if (isInitialLoad) {
        setFunListData([]);
      }
      
      // Colector temporal de datos para minimizar actualizaciones de estado
      let newFunListData = [];
      
      console.log('👉 FetchData iniciado', isInitialLoad ? '(carga inicial)' : '(actualización)');
      
      for (const chainId of supportedChainIds) {
        console.log(`🪙 [chain ${chainId}] solicitando precio ETH...`);
        // call Scan‑based price fetcher
        let ethPrice;
        try {
          ethPrice = await ethPriceApiUrl[chainId]();
        } catch (err) {
          console.warn(`⚠️ [chain ${chainId}] Scan API failed, using fallback`, err);
          ethPrice = initialEth1[chainId] ?? 0;
        }
        console.log(`✅ [chain ${chainId}] ethPrice =`, ethPrice);

        console.log(`🔍 [chain ${chainId}] llamando getMainInfo()`);
        const mainInfo = await readContract(config, {
          address: getMulticallAddress(chainId),
          abi: MultiCallAbi,
          functionName: 'getMainInfo',
          chainId,
        });

        console.log(`🔍 [chain ${chainId}] llamando getOtherInfo()`);
        const otherInfo = await readContract(config, {
          address: getMulticallAddress(chainId),
          abi: MultiCallAbi,
          functionName: 'getOtherInfo',
          chainId,
        });

        console.log(`🔍 [chain ${chainId}] llamando getRestInfo()`);
        const restInfo = await readContract(config, {
          address: getMulticallAddress(chainId),
          abi: MultiCallAbi,
          functionName: 'getRestInfo',
          chainId,
        });

        if (mainInfo[0].length > 0) {
          console.log(`➡️ Encontrados ${mainInfo[0].length} pools en chain ${chainId}`);
          for (let i = mainInfo[0].length - 1; i >= 0; i--) {
            let startTime = Number(mainInfo[0][i]);
            const lpCreated = restInfo[0][i];
            const contractAddress = mainInfo[5][i];
            const tokenAddress = otherInfo[6][i];
            const tokenPrice = Number(mainInfo[3][i]);
            const website = otherInfo[2][i];
            const twitter = otherInfo[3][i];
            const telegram = otherInfo[4][i];
            
            // Calculamos exactamente como en el archivo original
            const virtualLpAmounts = Number(mainInfo[2][i]) * ethPrice;
            const virtualLpTokenAmounts = Number(mainInfo[1][i]) / 10 ** 18;
            // Este marketCap solo se usa para el progreso
            const tempMarketCap = (tokenPrice * 1000000000 * Number(ethPrice)) / 10 ** 12;
            // Cálculo de progress
            let progress = lpCreated ? 100 : (tempMarketCap * 100) / 69000;
            // TVL (Liquidity)
            const liquidity = virtualLpAmounts * 2;
            // Valor real de marketCap que se muestra en los cards
            const marketCap = virtualLpAmounts / virtualLpTokenAmounts / 10 ** 9;
            
            const name = otherInfo[0][i];
            const symbol = otherInfo[1][i];
            const description = restInfo[1][i];
            const logoUrl = imageUrl + 'logo/' + projectName + "-" + chainId + "-" + contractAddress + '.png';
            const bannerUrl = imageUrl + 'banner/' + projectName + "-" + chainId + "-" + contractAddress + '.png';
            let blockchainLogoUrl = chainLogos[chainId];
            let devAddress = restInfo[3][i];
            let raisingPercent = Number(otherInfo[5][i]) / 100;
            let dexAddress = restInfo[2][i];
            let dexName = 'Uniswap';
            const funData = {
              chainId,
              startTime: startTime,
              progress: progress,
              Liquidity: liquidity,
              tokenName: name,
              tokenSymbol: symbol,
              tokenDescription: description,
              logoUrl: logoUrl,
              bannerUrl: bannerUrl,
              address: mainInfo[5][i],
              depositedAmount: (Number(mainInfo[4][i]) * ethPrice) / 10 ** 18,
              contractAddress: contractAddress,
              tokenAddress: tokenAddress,
              dexAddress: dexAddress,
              devAddress: devAddress,
              dexName: dexName,
              marketCap: marketCap,
              website: website,
              twitter: twitter,
              telegram: telegram,
              blockchainLogoUrl: blockchainLogoUrl,
              raisingPercent: raisingPercent,
              lpCreated,
            };
            
            // Agregar al colector temporal en lugar de actualizar el estado en cada iteración
            newFunListData.push(funData);
          }
        } else {
          console.log(`⚠️ No hay pools en chain ${chainId}`);
        }
      }
      
      // Actualizar el estado una sola vez con todos los datos recopilados
      setFunListData(newFunListData);
      
      if (isInitialLoad) {
        setLoading(false);
      }
      console.log('✅ FetchData completado');
    } catch (e) {
      if (isInitialLoad) {
        setLoading(false);
      }
      console.error('❌ Error en FetchData:', e);
    }
  }, [supportedChainIds]); // Solo se recreará cuando cambie supportedChainIds

  // Función para obtener streams activos (refactorizada desde useEffect)
  const fetchActive = useCallback(async () => {
    console.log('[Board] fetching active streams from', `${apiUrl}/api/active-streams`);
    try {
      const res = await fetch(`${apiUrl}/api/active-streams`);
      console.log('[Board] active-streams response status:', res.status);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const data = await res.json();
      console.log('[Board] active streams data:', data);
      setActiveStreamAddrs(data.map((s) => s.tokenAddress));
    } catch (err) {
      console.error('[Board] fetchActive error:', err);
    }
  }, [apiUrl]);

  // Referencia para el temporizador de actualización
  const updateTimerRef = useRef(null);

  // Función para programar la próxima actualización
  const scheduleNextUpdate = useCallback(() => {
    // Limpiar cualquier temporizador existente para evitar memory leaks
    if (updateTimerRef.current) {
      clearTimeout(updateTimerRef.current);
    }
    
    // Programar la próxima actualización
    updateTimerRef.current = setTimeout(() => {
      console.log('🔄 Ejecutando actualización programada...');
      // Solo actualizar si el documento está visible para ahorrar recursos
      if (!document.hidden) {
        FetchData(false); // false indica que no es carga inicial
        fetchActive();
        // Programar la siguiente actualización después de completar esta
        scheduleNextUpdate();
      } else {
        console.log('⏸️ Página no visible, posponiendo actualización...');
        // Si la página no está visible, reprogramar para más tarde
        scheduleNextUpdate();
      }
    }, UPDATE_INTERVAL);
    
    console.log(`⏱️ Próxima actualización programada en ${UPDATE_INTERVAL/1000} segundos`);
  }, [FetchData, fetchActive]);

  // useEffect para la carga inicial y configurar actualizaciones periódicas
  useEffect(() => {
    // Carga inicial de datos
    FetchData(true); // true indica carga inicial
    fetchActive();
    
    // Configurar actualizaciones periódicas
    scheduleNextUpdate();
    
    // Evento para reanudar actualizaciones cuando la página vuelve a estar visible
    const handleVisibilityChange = () => {
      if (!document.hidden && updateTimerRef.current === null) {
        console.log('▶️ Página visible de nuevo, reanudando actualizaciones...');
        scheduleNextUpdate();
      }
    };
    
    document.addEventListener('visibilitychange', handleVisibilityChange);
    
    // Limpieza al desmontar
    return () => {
      console.log('🧹 Limpiando recursos...');
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      if (updateTimerRef.current) {
        clearTimeout(updateTimerRef.current);
        updateTimerRef.current = null;
      }
    };
  }, [FetchData, fetchActive, scheduleNextUpdate]);

  const sortOptions = [
    { value: 'Creation Time', label: 'Creation Time' },
    { value: 'Market Cap', label: 'Market Cap' },
    { value: 'Volume', label: 'Volume' },
  ];

  const orderOptions = [
    { value: 'Descending', label: 'Descending' },
    { value: 'Ascending', label: 'Ascending' },
  ];

  const statusOptions = [
    { value: 'All', label: 'All' },
    { value: 'Listed', label: 'Listed' },
    { value: 'Live', label: 'Live' },
  ];

  const chainOptions = [
    { value: 'All Chains', label: 'All Chains' },
    { value: 'BSC Testnet', label: 'BSC Testnet' },
  ];

  function FilterSelect({ options, defaultValue, onChange }) {
    const handleChange = (newValue) => {
      onChange(newValue);
    };

    return (
      <Select
        defaultValue={defaultValue}
        isSearchable={false}
        options={options}
        value={options.find((option) => option.value === defaultValue.value)}
        onChange={handleChange}
        styles={{
          control: (styles) => ({
            ...styles,
            color: 'black',
            padding: '4px 0px',
            background: 'linear-gradient(to right, #1c5290, #45c0be)',
            border: '1px solid black',
            boxShadow: 'rgb(0, 0, 0) 1px 1px 0px 0px',
            borderRadius: '10px',
            cursor: 'pointer',
            outline: 'none',
            '&:hover': {
              boxShadow: 'rgb(0, 0, 0) 1px 1px 0px 0px',
            },
            '&:focus': {
              boxShadow: 'rgb(0, 0, 0) 1px 1px 0px 0px',
            },
            '&:active': {
              boxShadow: 'rgb(0, 0, 0) 1px 1px 0px 0px',
            },
          }),
          option: (styles, { isFocused, isSelected }) => ({
            ...styles,
            backgroundColor: isFocused ? (isSelected ? '#7db4e5' : '#7db4e5') : '#f3f3f3',
            color: 'black',
            cursor: 'pointer',
            zIndex: '9999',
          }),
          singleValue: (styles) => ({
            ...styles,
            color: 'white',
            outline: 'none',
          }),
          indicatorSeparator: (styles) => ({
            ...styles,
            display: 'none',
          }),
          dropdownIndicator: (styles) => ({
            ...styles,
            color: 'white',
            '&:hover': {
              color: 'white',
            },
          }),
          menuList: (styles) => ({
            ...styles,
            background: '#f3f3f3',
            borderRadius: '5px',
          }),
        }}
      />
    );
  }

  const [sortedFunLists, setSortedFunLists] = useState([]);
  const [filteredFunLists, setFilteredFunLists] = useState([]);
  const [sortValue, setSortValue] = useState(sortOptions[0]);
  const [orderValue, setOrderValue] = useState(orderOptions[0]);
  const [statusValue, setStatusValue] = useState(statusOptions[0]);
  const [chainValue, setChainValue] = useState(chainOptions[0]);

  const filterFunLists = useCallback(() => {
    const searchFiltered = funLists.filter((list) => {
      if (!search || search === '') {
        return true;
      }

      const searchLower = search.toLowerCase();

      if (list.tokenName.toLowerCase().includes(searchLower)) {
        return true;
      }
      return false;
    });
    let chainFilteredList = [];
    switch (chainValue.value) {
      case 'All Chains':
        chainFilteredList = [...searchFiltered];
        break;
      case 'BSC Testnet':
        chainFilteredList = [...searchFiltered.filter((item) => item.chainId === 97)];
        break;
      default:
        break;
    }
    let filteredList = [];
    switch (statusValue.value) {
      case 'All':
        filteredList = [...chainFilteredList];
        break;
      case 'Listed':
        filteredList = [...chainFilteredList.filter((item) => item.progress >= 100)];
        break;
      case 'Live':
        filteredList = [...chainFilteredList.filter((item) => item.progress < 100)];
        break;
      default:
        break;
    }
    setFilteredFunLists(filteredList);
  }, [statusValue, chainValue, funLists, search]);

  const onSearchChanged = (event) => {
    setSearch(event.target.value);
  };

  const sortFunLists = useCallback(async () => {
    let sortedList = [];
    switch (sortValue.value) {
      case 'Market Cap':
        sortedList = [...filteredFunLists].sort((a, b) => {
          if (orderValue.value === 'Ascending') {
            return a.marketCap - b.marketCap;
          } else {
            return b.marketCap - a.marketCap;
          }
        });
        break;
      case 'Creation Time':
        sortedList = [...filteredFunLists].sort((a, b) => {
          if (orderValue.value === 'Ascending') {
            return a.startTime - b.startTime;
          } else {
            return b.startTime - a.startTime;
          }
        });
        break;
      case 'Volume':
        sortedList = [...filteredFunLists].sort((a, b) => {
          if (orderValue.value === 'Ascending') {
            return a.depositedAmount - b.depositedAmount;
          } else {
            return b.depositedAmount - a.depositedAmount;
          }
        });
        break;
      default:
        break;
    }
    setAllLists(sortedList);
    let last;
    let length = sortedList.length;
    setTotalLength(length);
    let datas = [];
    if (length > 12) {
      last = 12;
    } else {
      last = length;
    }
    for (let i = 0; i < last; i++) {
      datas.push(sortedList[i]);
    }
    setCurrentIndex(last);
    setSortedFunLists(datas);
  }, [orderValue, sortValue, filteredFunLists]);

  useEffect(() => {
    setFilteredFunLists([...funLists]);
  }, [funLists, statusValue]);

  useEffect(() => {
    filterFunLists();
  }, [statusValue, filterFunLists]);

  useEffect(() => {
    sortFunLists();
  }, [orderValue, sortValue, filteredFunLists, sortFunLists]);

  const onSortChange = (newValue) => {
    setSortValue(newValue);
    sortFunLists();
  };

  const onChainChange = (val) => {
    setChainValue(val);
    filterFunLists();
  };

  const onOrderChange = () => {
    if (orderValue.value === 'Descending') {
      setOrderValue(orderOptions[1]);
    } else {
      setOrderValue(orderOptions[0]);
    }
    sortFunLists();
  };

  const onStatusChange = (newValue) => {
    setStatusValue(newValue);
    filterFunLists();
  };

  const loadMoreLists = () => async () => {
    try {
      setLoading(true);
      let newLists = [];
      let last;
      const length = totalLength - currentIndex;
      if (length >= 0) {
        if (length > 12) {
          last = currentIndex + 12;
        } else {
          last = currentIndex + length;
        }
        for (let i = currentIndex; i < last; i++) {
          newLists.push(allLists[i]);
        }
        let newDatas = sortedFunLists.concat(newLists);
        setSortedFunLists(newDatas);
        setCurrentIndex(last);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      console.error(e);
    }
  };

  const LaunchpadCardGrid = ({ items }) => (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-5 px-3">
      {items.map((pool, i) => (
        <LaunchpadCard
          key={`${pool.contractAddress}-${i}`}
          {...pool}
          // pass explicit funAddress for correct routing
          funAddress={pool.contractAddress}
          isLive={activeStreamAddrs.includes(pool.tokenAddress)}
        />
      ))}
    </div>
  )

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
    cookies.set('show-how-it-works', 'true');
  };

  const closeModal = (e) => {
    if (e.target.id === 'modal') {
      setModalIsOpen(false);
      cookies.set('show-how-it-works', 'true');
    }
  };

  const modalContent = (
    <div id="modal" onClick={closeModal} className={`modal ${modalIsOpen ? 'show-modal' : ''}`}>
      <div className="bg-[#f3f3f3] rounded-[10px] max-w-[480px] p-[24px]">
        <h1 className="text-center text-xl pb-2 font-extrabold">All created tokens in MemeLaunch are safe!</h1>
        <p className="text-[#222]">✅Each coin is a fair-launch with no presale and no team allocation.</p>
        <p className="text-[#222]">✅Everyone has equal chance!</p>
        <h1 className="text-center text-xl pb-2 font-extrabold">How it works</h1>
        <p className="text-[#222]">1️⃣ pick a coin that you like</p>
        <p className="text-[#222]">2️⃣ buy the coin on the bonding curve</p>
        <p className="text-[#222]">3️⃣ sell at any time to lock in your profits or losses</p>
        <p className="text-[#222]">
          4️⃣ when enough people buy on the bonding curve it reaches a market cap of $69k and the token will be listed with $12k of liquidity deposited in the preferred DEX.
        </p>
        <p className="text-[#222] mb-4">5️⃣LP Tokens will be burned🔥</p>
        <p className="text-[#222] italic text-[14px]">Disclaimer:</p>
        <p className="text-[#222] italic text-[14px]">
          Trading tokens is highly risky / speculative. Do not invest more than you can afford to lose. Anyone can list a token, listing does not mean we endorse the token. Token prices can be extremely volatile. Be sure to follow any legal guidelines that your country specifies.
        </p>
        <div className="text-center mt-4">
          <button onClick={toggleModal} className="rounded-full bg-[#2f6434] px-4 py-3 text-white">
            I'm ready to pump
          </button>
        </div>
      </div>
    </div>
  );

  return (
    <div>
      <style>{`
        .modal {
          opacity: 0;
          visibility: hidden;
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          transition: all 0.3s ease;
          z-index: 10;
        }

        .show-modal {
          opacity: 1;
          visibility: visible;
        }
        
        /* Estilos para corregir el carrusel */
        .carousel-track {
          display: flex !important;
          animation: scroll 60s linear infinite !important; /* Reactivamos la animación */
          white-space: nowrap !important;
        }
        
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-100%); /* Cambiamos a -100% para un scroll completo */
          }
        }
      `}</style>
      {modalContent}
      <div className="GlobalContainer" style={contentStyle}>
        <div className="max-w-7xl m-auto px-4 sm:px-12">
          {/* Banner de Video - Solo visible en la página board */}
          <div className="w-full md:max-w-4xl mx-auto bg-black rounded-lg overflow-hidden mt-[20px] mb-[10px]">
            <video
              src={bannerVideo}
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-auto max-h-[60px] object-cover"
            >
              Tu navegador no soporta el elemento de video.
            </video>
          </div>
          
          {/* Solo mostrar los tokens que realmente están en presale (cruzando la curva) */}
          {funLists && funLists.filter((item) => 
          item.progress > 10 && // Mínimo 10% de progreso
          item.progress < 100 && 
          item.marketCap > 5000 && // MarketCap significativo
          item.lpCreated === false &&
          item.depositedAmount > 0 // Asegurar que haya depósitos reales
          ).length > 0 && (
            <div className="flex flex-col mt-[36px] xl:mt-[18px]">
              <div className="text-[#f3f3f3] text-xl">Projects 🚀</div>
              <Slider 
                items={funLists.filter((item) => 
                  item.progress > 10 && // Aumentamos el umbral mínimo de progreso a 10%
                  item.progress < 100 && 
                  item.marketCap > 5000 && // Aumentamos el umbral mínimo de marketCap
                  item.lpCreated === false &&
                  item.depositedAmount > 0 // Aseguramos que haya depósitos reales
                )} 
                isListed={false} 
              />
            </div>
          )}
          
          <div className="my-1 flex m-auto justify-center gap-4">
            <Link
              to="/create"
              className="relative flex h-[50px] w-[167px] items-center justify-center rounded-[16px] bg-gradient-to-r from-[#1c5290]  to-[#45c0be] text-subtitle1 text-white"
            >
              Create Token
            </Link>
            <a
              href="https://app.uniswap.org/swap"
              target="_blank"
              rel="noopener noreferrer"
              className="relative flex h-[50px] w-[167px] items-center justify-center rounded-[16px] bg-gradient-to-r from-[#1c5290]  to-[#45c0be] text-subtitle1 text-white"
            >
              DEX
            </a>
          </div>
          <div className="grid xl:grid-cols-2 gap-12">
            <div className="flex flex-col">
              <div className="text-center text-[#fff] text-xl mb-1.5">Market Cap</div>
              <div className="bg-[#6d79ad33] rounded-[10px] lg:px-8 px-2.5 py-5 backdrop-blur-[8px] border-2 border-[#ffffff66]">
                <div className="w-full text-xs sm:text-sm">
                  <div className="grid grid-cols-6 text-[#cfcfcf]">
                    <div className="uppercase text-center px-2 py-3">Rank</div>
                    <div className="uppercase text-center px-2 py-3 col-span-2">Token Name</div>
                    <div className="uppercase text-center px-2 py-3">MarketCap</div>
                    <div className="uppercase text-center px-2 py-3 col-span-2">Progress</div>
                  </div>
                  <div className="gap-2 flex flex-col text-[#f8ffe8] overflow-y-auto no-scrollbar h-[268px]">
                    {loading && (
                      <div className="bg-[#010101] rounded-[10px]">
                        <div className="px-4 py-3 text-center">Loading...</div>
                      </div>
                    )}
                    {!loading && funLists?.length === 0 && (
                      <div className="bg-[#010101] rounded-[10px]">
                        <div className="px-4 py-2.5 text-center">No Data</div>
                      </div>
                    )}
                    {!loading &&
                      funLists &&
                      funLists
                        .sort((a, b) => b.marketCap - a.marketCap)
                        .slice(0, 10)
                        .map((pool, index) => (
                          <div
                            key={index}
                            className="cursor-pointer"
                            onClick={() =>
                              history.push(`/buy/?chain=${pool.chainId}&address=${pool.address}`)
                            }
                          >
                            <div className="grid grid-cols-6 bg-[#010101] rounded-[10px] items-center text-xs sm:text-sm">
                              <div className="px-2 sm:px-4 py-2.5 rounded-l-[10px] text-center">{index + 1}</div>
                              <div className="py-2.5 font-semibold lg:font-normal col-span-2">
                                <div className="flex flex-row items-center text-[#0360b9] border border-[#1c5290] rounded-full w-fit">
                                  <img src={pool.logoUrl} className="h-[30px] w-[30px] rounded-full" />
                                  <div className="text-[10px] sm:text-[12px] inline-block whitespace-nowrap w-24 mx-1 sm:mx-3 overflow-hidden">
                                    {pool.tokenName}
                                  </div>
                                </div>
                              </div>
                              <div className="px-2 sm:px-4 py-2.5">${Math.round(pool.marketCap).toLocaleString()}</div>
                              <div className="px-2 sm:px-4 py-2.5 rounded-r-[10px] col-span-2">
                                <div className="flex flex-col items-center sm:w-full w-10/12">
                                  <div className="text-gray-400">
                                    {Number(pool.progress > 100 ? 100 : pool.progress).toFixed(2)}%
                                  </div>
                                  <div className="launchpad-progress-bar h-[8px]">
                                    <div
                                      className="launchpad-progress-bar-filled h-[6px]"
                                      style={{ width: `${pool.progress > 100 ? 100 : pool.progress}%`, marginTop: "1px" }}
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="flex flex-col">
              <div className="text-center text-[#fff] text-xl mb-1.5">24h Gainers</div>
              <div className="bg-[#6d79ad33] rounded-[10px] lg:px-8 px-2.5 py-5 backdrop-blur-[8px] border-2 border-[#ffffff66]">
                <div className="w-full text-xs sm:text-sm">
                  <div className="grid grid-cols-6 text-[#cfcfcf]">
                    <div className="uppercase text-center px-2 py-3">Rank</div>
                    <div className="uppercase text-center px-2 py-3 col-span-2">Token Name</div>
                    <div className="uppercase text-center px-2 py-3">MarketCap</div>
                    <div className="uppercase text-center px-2 py-3 col-span-2">Rise</div>
                  </div>
                  <div className="gap-2 flex flex-col text-[#f8ffe8] overflow-y-auto no-scrollbar h-[268px]">
                    {loading && (
                      <div className="bg-[#010101] rounded-[10px]">
                        <div className="px-4 py-3 text-center">Loading...</div>
                      </div>
                    )}
                    {!loading &&
                      !loading &&
                      funLists?.length === 0 && (
                        <div className="bg-[#010101] rounded-[10px]">
                          <div className="px-4 py-2.5 text-center">No Data</div>
                        </div>
                      )}
                    {!loading &&
                      funLists &&
                      funLists
                        .sort((a, b) => b.raisingPercent - a.raisingPercent)
                        .slice(0, 10)
                        .map((pool, index) => (
                          <div
                            key={index}
                            className="cursor-pointer"
                            onClick={() =>
                              history.push(`/buy/?chain=${pool.chainId}&address=${pool.address}`)
                            }
                          >
                            <div className="grid grid-cols-6 bg-[#010101] rounded-[10px] items-center text-xs sm:text-sm">
                              <div className="px-2 sm:px-4 py-2.5 rounded-l-[10px] text-center">{index + 1}</div>
                              <div className="px-2 sm:px-4 py-2.5 rounded-r-[10px] col-span-2">
                                <div className="flex flex-row items-center text-[#0360b9] border border-[#1c5290] rounded-full w-fit">
                                  <img src={pool.logoUrl} className="h-[30px] w-[30px] rounded-full" />
                                  <div className="text-[10px] sm:text-[12px] inline-block whitespace-nowrap w-24 mx-1 sm:mx-3 overflow-hidden">
                                    {pool.tokenName}
                                  </div>
                                </div>
                              </div>
                              <div className="px-2 sm:px-4 py-2.5">${Math.round(pool.marketCap).toLocaleString()}</div>
                              <div className="flex gap-1 justify-center text-[#00ff05] px-2 sm:px-4 py-2.5 rounded-r-[10px] col-span-2">
                                {pool.raisingPercent}%
                                <svg fill="#f600ff" viewBox="0 0 11 18" width="11" className="animation-increasing">
                                  <g>
                                    <path d="M3.21533 7.62257V16.9824C3.21533 17.5347 3.64908 17.9998 4.34309 17.9998H6.48294C7.03236 17.9998 7.6107 17.5638 7.6107 16.9824V7.62257H9.75056C10.994 7.62257 11.341 6.80866 10.647 5.90756L6.80103 0.67534C6.13594 -0.225764 4.97926 -0.225764 4.1985 0.67534L0.352553 5.90756C-0.341453 6.83773 0.00554999 7.62257 1.24898 7.62257H3.21533Z"></path>
                                  </g>
                                </svg>
                              </div>
                            </div>
                          </div>
                        ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {funLists.filter((item) => item.progress >= 100).length > 0 && (
            <div className="flex flex-col mt-[36px] xl:mt-[18px]">
              <div className="text-[#f3f3f3] text-xl">Listed Projects</div>
              <Slider items={funLists.filter((item) => item.progress >= 100)} isListed={true} />
            </div>
          )}

          <div className="py-[32px] w-full h-auto">
            <div className="flex flex-col lg:flex-row gap-3 lg:gap-2.5 h-full justify-between">
              <div className="flex flex-wrap gap-2">
                {sortOptions.map((option) => (
                  <button
                    key={option.value}
                    className={`sort-button ${sortValue.value === option.value ? 'bg-gradient-to-r from-[#1c5290]  to-[#45c0be]' : ''}`}
                    onClick={() => onSortChange(option)}
                  >
                    {option.label}
                  </button>
                ))}
              </div>
              <div className="flex flex-col gap-2 text-[14px] lg:flex-row">
                <div
                  className="border border-[#f3f3f3] rounded-full relative w-full lg:w-[300px] h-10 lg:h-full"
                >
                  <svg fill="#222" viewBox="0 0 18 18" width="18" className="top-3 left-[14px] absolute">
                    <g>
                      <path d="M7.75987 15.5197C3.48078 15.5197 0 12.039 0 7.75987C0 3.48078 3.48078 0 7.75987 0C12.039 0 15.5197 3.48078 15.5197 7.75987C15.5197 12.039 12.039 15.5197 7.75987 15.5197ZM7.75987 1.90911C4.53381 1.90911 1.90911 4.53381 1.90911 7.75855C1.90911 10.9833 4.53381 13.608 7.75987 13.608C10.9859 13.608 13.6106 10.9833 13.6106 7.75855C13.6106 4.53381 10.9859 1.91042 7.75987 1.91042V1.90911Z"></path>
                      <path d="M16.8235 17.9987C16.5228 17.9987 16.2221 17.8845 15.9924 17.6547L11.9378 13.6001C11.4783 13.1406 11.4783 12.3974 11.9378 11.9379C12.3974 11.4783 13.1418 11.4783 13.6001 11.9379L17.6546 15.9924C18.1142 16.452 18.1142 17.1951 17.6546 17.6547C17.4249 17.8845 17.1242 17.9987 16.8235 17.9987Z"></path>
                    </g>
                  </svg>
                  <input
                    className="bg-transparent placeholder:text-[#fff] placeholder:text-sm focus:outline-none py-[12px] pr-8 pl-[44px] border rounded-2xl w-full h-full text-[#f8ffe8] backdrop-contrast-[.7]"
                    placeholder="Search Token"
                    onChange={onSearchChanged}
                  />
                </div>
                <div className='flex flex-row gap-1'>
                  <FilterSelect options={statusOptions} defaultValue={statusValue} onChange={onStatusChange} />
                  <FilterSelect options={chainOptions} defaultValue={chainValue} onChange={onChainChange} />
                  <button
                    className="bg-gradient-to-r from-[#1c5290]  to-[#45c0be] rounded-full p-2"
                    onClick={onOrderChange}
                    style={{
                      border: '1px solid black',
                      boxShadow: 'rgb(0, 0, 0) 1px 1px 0px 0px',
                      borderRadius: '10px',
                    }}
                  >
                    {orderValue.label === 'Ascending' ? (
                      <svg fill="#ffffff" viewBox="0 0 21 17" width="21" className="fill-white transition-transform">
                        <g>
                          <path d="M17.2974 12.6684L19.0757 10.8901C19.5165 10.4493 20.2292 10.4493 20.67 10.8901C21.1109 11.331 21.1109 12.0437 20.67 12.4845L17.0607 16.0925C16.9025 16.2953 16.6807 16.4387 16.4306 16.4982C15.8274 16.651 15.2148 16.2872 15.062 15.6841C15.0228 15.5299 15.0174 15.3703 15.0444 15.2135V1.12783C15.0444 0.505763 15.5488 0 16.1723 0C16.7957 0 17.3001 0.504411 17.3001 1.12783V12.6684H17.2974ZM1.12783 1.45373H10.8942C11.5163 1.45373 12.022 1.95814 12.022 2.58156C12.022 3.20497 11.5176 3.70938 10.8942 3.70938H1.12783C0.504411 3.70803 0 3.20362 0 2.5802C0 1.95679 0.504411 1.45373 1.12783 1.45373ZM1.12783 7.46474H10.8942C11.5163 7.44446 12.0383 7.93264 12.0585 8.5547C12.0788 9.17677 11.5906 9.69876 10.9686 9.71904C10.9442 9.71904 10.9185 9.71904 10.8942 9.71904H1.12783C0.505763 9.71904 0 9.21463 0 8.59122C0 7.9678 0.504411 7.46339 1.12783 7.46339V7.46474ZM1.12783 13.4758H10.8942C11.5163 13.4758 12.022 13.9802 12.022 14.6036C12.022 15.227 11.5176 15.7314 10.8942 15.7314H1.12783C0.505763 15.7314 0 15.227 0 14.6036C0 13.9802 0.504411 13.4758 1.12783 13.4758Z"></path>
                        </g>
                      </svg>
                    ) : (
                      <svg fill="#ffffff" viewBox="0 0 21 17" width="21" className="fill-white transition-transform rotate-180">
                        <g>
                          <path d="M17.2974 12.6684L19.0757 10.8901C19.5165 10.4493 20.2292 10.4493 20.67 10.8901C21.1109 11.331 21.1109 12.0437 20.67 12.4845L17.0607 16.0925C16.9025 16.2953 16.6807 16.4387 16.4306 16.4982C15.8274 16.651 15.2148 16.2872 15.062 15.6841C15.0228 15.5299 15.0174 15.3703 15.0444 15.2135V1.12783C15.0444 0.505763 15.5488 0 16.1723 0C16.7957 0 17.3001 0.504411 17.3001 1.12783V12.6684H17.2974ZM1.12783 1.45373H10.8942C11.5163 1.45373 12.022 1.95814 12.022 2.58156C12.022 3.20497 11.5176 3.70938 10.8942 3.70938H1.12783C0.504411 3.70803 0 3.20362 0 2.5802C0 1.95679 0.504411 1.45373 1.12783 1.45373ZM1.12783 7.46474H10.8942C11.5163 7.44446 12.0383 7.93264 12.0585 8.5547C12.0788 9.17677 11.5906 9.69876 10.9686 9.71904C10.9442 9.71904 10.9185 9.71904 10.8942 9.71904H1.12783C0.505763 9.71904 0 9.21463 0 8.59122C0 7.9678 0.504411 7.46339 1.12783 7.46339V7.46474ZM1.12783 13.4758H10.8942C11.5163 13.4758 12.022 13.9802 12.022 14.6036C12.022 15.227 11.5176 15.7314 10.8942 15.7314H1.12783C0.505763 15.7314 0 15.227 0 14.6036C0 13.9802 0.504411 13.4758 1.12783 13.4758Z"></path>
                        </g>
                      </svg>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
          {sortedFunLists.length > 0 ? (
            <>
              <LaunchpadCardGrid items={sortedFunLists} />
              {loading === true ? (
                <div className="loadingBox">
                  <div className="EmptyLaunchpad">
                    <div className="loadingBox">
                      <p className="Text1" style={{ color: 'white' }}>
                        Loading...
                      </p>
                      <ClipLoader
                        color={'#afccc6'}
                        loading={true}
                        size={50}
                        aria-label="Loading Spinner"
                        data-testid="loader"
                      />
                    </div>
                  </div>
                </div>
              ) : totalLength - currentIndex > 0 ? (
                <p className="bg-[#050f1a] rounded-full p-4 loadMoreText" onClick={loadMoreLists()}>
                  Load more...
                </p>
              ) : (
                <></>
              )}
            </>
          ) : (
            <div className="loadingBox">
              <p className="Text1" style={{ color: 'white' }}>No data yet</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default App;